<lyceo-content [background]="true" *transloco="let t">
  <div class="home-grid">
    <lyceo-card>
      <h3 class="mb-3">{{ t('pages.home.title') }}</h3>
      <p class="mb-3">{{ t('pages.home.description') }}</p>
      <p>{{ t('pages.home.feedback') }}</p>
    </lyceo-card>
    <lyceo-card class="img-card">
      <img src="assets/img/lassie-eat-homi-slogan.png" />
    </lyceo-card>
    <lyceo-shared-task-counts class="task-counts" />
  </div>
</lyceo-content>
